var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M0 317.791h512v44.14H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.945 170.868l-8.683 26.034-27.443.213c-2.632.02-3.723 3.379-1.606 4.942l22.077 16.302-8.278 26.165c-.793 2.509 2.063 4.585 4.204 3.054l22.327-15.958 22.327 15.958c2.141 1.53 4.998-.545 4.204-3.054l-8.278-26.165 22.077-16.302c2.118-1.564 1.026-4.921-1.606-4.942l-27.443-.213-8.683-26.034c-.832-2.497-4.363-2.497-5.196 0zM56.393 122.826l-5.025 15.069-15.884.124c-1.523.012-2.155 1.955-.929 2.86l12.778 9.436-4.791 15.145c-.459 1.452 1.194 2.654 2.433 1.768l12.922-9.237 12.922 9.237c1.239.886 2.893-.316 2.433-1.768l-4.791-15.145 12.778-9.436c1.225-.905.594-2.849-.929-2.86l-15.884-.124-5.025-15.069c-.482-1.445-2.526-1.445-3.008 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/cw.04990c719a636d2943d7d760599b1d65.svg";
export { ForwardRef as ReactComponent };